import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const RentBasic = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.rentdetail"));
  const increaseOptions = _.map(props.namedItems['increase'], (i) => { return {label: i.code, value: i.increaseid} })

  const emptyRecord = {
    amt: null,
    amtType: props.defaults["rentAmtType"],
    increaseNamedItemId: _.get(props, "defaults.increase")
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)

    _.set(nextData, field, val)
    if(!_.get(nextData, "increaseNamedItemId")) _.set(nextData, "increaseNamedItemId", _.get(props, "defaults.increase"))

    delete nextData.items
    delete nextData.rentNamedItemId

    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'rentdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rent', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput
            field="amt"
            className="automated"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000000}
            readPrecision={4}
            writePrecision={4}
            trailingZeros={false}
            persist={updateData}/>
        </div>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['rentAmtType']}
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr', '% of Market']}
            persist={updateData}/>
        </div>
        <div>
          <label>Increase</label>
          <DropdownInput
            className="automated named-item-state-input"
            data={data}
            default={_.get(props, "defaults.increase")}
            attrs={attrs}
            field="increaseNamedItemId"
            filter={true}
            options={increaseOptions}
            persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default RentBasic
